module.exports = __webpack_public_path__ + "static/media/qr_code2.73e76520.png";